import importSvgIcons from './importSvgIcons';

export default importSvgIcons(
  require.context(
    `../../client/assets/brands/chevrolet/chevrolet-ev/svg`,
    true,
    /\.svg$/
  )
);
